import { render } from "./InviteInstructor.vue?vue&type=template&id=19ed790a&scoped=true"
import script from "./InviteInstructor.vue?vue&type=script&lang=js"
export * from "./InviteInstructor.vue?vue&type=script&lang=js"

import "./InviteInstructor.vue?vue&type=style&index=0&id=19ed790a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ed790a"]])

export default __exports__